export default {
  title: 'School Management',
  menu: 'School Management',
  label: {
    schoolChineseName: 'School Chinese Name',
    schoolEnglishName: 'School English Name',
    reviewStatus: 'Review Status',
    edit: 'Edit',
    addSchool: 'Add School',
    editSchool: 'Edit School',
    mergeTo: 'Merge to'
  },
  reviewStatus: {
    yes: 'Yes',
    no: 'No'
  },
  placeholder: {
    keywords: 'Search school Chinese name',
    pleaseStartTyping: 'Please Start Input'
  },
  message: {
    saveSuccess: 'Save Success',
    saveFail: 'Save Fail'
  }
}
